export const getDevAuth = state => state.toJS();

export const isFetching = state => state.get('isFetching');



// WEBPACK FOOTER //
// ./src/redux/selectors/DevAuthSelectors.js